export const defaultStyle = {
    wrapper: "relative w-full flex justify-center items-center max-w-[310px] lg:shrink-0 lg:max-w-[560px] xlg:max-w-[588px]",
}
